import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    analysis: {},
    model: {},
    objVar: "",
    expVars: [],
    nodeTimeLags: {},
    nodeTimeLagsDisplay: {},
  },
  reducers: {
    setUserAnalysis: (state, action) => {
      state.analysis = action.payload;
    },
    setUserModel: (state, action) => {
      state.model = action.payload;
    },
    setUserObjVar: (state, action) => {
      state.objVar = action.payload;
    },
    setUserExpVars: (state, action) => {
      state.expVars = action.payload;
    },
    setUserNodeTimeLags: (state, action) => {
      state.nodeTimeLags = action.payload;
    },
    setUINodeTimeLagsDisplay: (state, action) => {
      state.nodeTimeLagsDisplay = action.payload;
    },
  },
});

export const {
  setUserAnalysis,
  setUserModel,
  setUserObjVar,
  setUserExpVars,
  setUserNodeTimeLags,
  setUINodeTimeLagsDisplay,
} = userSlice.actions;

export const selectUserAnalysis = (state) => state.user.analysis;
export const selectUserModel = (state) => state.user.model;
export const selectUserObjVar = (state) => state.user.objVar;
export const selectUserExpVars = (state) => state.user.expVars;
export const selectUserNodeTimeLags = (state) => state.user.nodeTimeLags;
export const selectUINodeTimeLagsDisplay = (state) =>
  state.user.nodeTimeLagsDisplay;

export default userSlice.reducer;
